require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("to-querystring", [], t) : "object" == typeof exports ? exports["to-querystring"] = t() : e["to-querystring"] = t();
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, o) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 0);
  }([function (e, t, n) {
    "use strict";

    function o(e, t, n) {
      if ("object" === (void 0 === t ? "undefined" : i(t))) {
        return "" + u(t, "" + n + ("" + e + (n && "]") + "["));
      }

      return n && n.length ? "" + n + e + "]=" + encodeURIComponent(t) : e + "=" + encodeURIComponent(t);
    }

    function r(e, t, n) {
      return t.map(function (t) {
        return o(e, t, n);
      }).join("&");
    }

    function u(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          u = n.arrayPrefix || "",
          i = [];
      return i = Array.isArray(e) ? e.map(function (e, n) {
        return o("" + n + u, e, t);
      }) : Object.keys(e).filter(function (t) {
        return void 0 !== e[t];
      }).map(function (n) {
        return e[n] && Array.isArray(e[n]) ? r("" + n + u, e[n], t) : o(n, e[n], t);
      }), i.join("&").replace(/%20/g, "+");
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };
    t["default"] = u;
  }]);
});